export default __webpack_public_path__ + "static/media/zoom.ade7bdcf.svg";